<template>
  <div class="div1">
    <mu-appbar  style="width: 100%;height:40px;" color="primary">
      <span style="font-size: 14px;">登录</span>
    </mu-appbar>
    <div class="div11">
      <mu-container class="mu-container">
        <mu-form ref="form" :model="validateForm" class="mu-demo-form">
          <mu-form-item label="用户名" label-float prop="username" :rules="usernameRules">
            <mu-text-field v-model="validateForm.username" prop="username"></mu-text-field>
          </mu-form-item>
          <mu-form-item label="密码" label-float prop="password" :rules="passwordRules">
            <mu-text-field type="password" v-model="validateForm.password" prop="password" :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'"></mu-text-field>
          </mu-form-item>
          <mu-form-item>
            <mu-button color="primary" @click="submit">提交</mu-button>
            <mu-button @click="clear">重置</mu-button>
          </mu-form-item>
        </mu-form>
      </mu-container>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import Toast from 'muse-ui-toast';

  export default {
    data () {
      return {
        usernameRules: [
          { validate: (val) => !!val, message: '必须填写用户名'},
          { validate: (val) => val.length >= 2, message: '用户名长度大于1'}
        ],
        passwordRules: [
          { validate: (val) => !!val, message: '必须填写密码'},
          { validate: (val) => val.length >= 6 && val.length <= 10, message: '密码长度大于6小于10'}
        ],
        validateForm: {
          username: '',
          password: ''
        }
      }
    },
    mounted () {
    },
    methods: {
      submit () {
        let _this = this;
        let loading = null;
        this.$refs.form.validate().then((result) => {
          result?(
            loading = _this.$loading(),
            axios.post('/stock/login.mvc', Qs.stringify({
            name: _this.validateForm.username,
            pw: _this.validateForm.password,
            system_id : 'A'
          }))
            .then(function (response) {
              loading.close();
              console.log(response);
              if(response.data == "1"){
                _this.STORE.login.name = _this.validateForm.username;
                _this.$router.replace("/Home");
              }
              if(response.data == "0"){
                Toast.error('没有注册或者用户名密码错误！');
              }
              if(response.data == "3"){
                Toast.error('登录异常！');
              }
            })
            .catch(function (error) {
              loading.close();
              console.log(error);
            })):(null);
          // console.log('form valid: ', result);
        });
      },
      clear () {
        this.$refs.form.clear();
        this.validateForm = {
          username: '',
          password: '',
          isAgree: false
        };
      }
    }
  };
</script>

<style scoped>
  .div1{
    display: flex;
    flex-direction: column;
    min-height: 300px;
  }
  .div11{
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;

    justify-content: center;
    align-items: center;
  }
  .mu-form-item-label{
    font-size: 16px;
  }
  .mu-container{
    min-width:250px;
    width:250px;
  }
  .mu-demo-form {
    width: 100%;
    max-width: 460px;
  }
  .mu-form-item-content{
    text-align: center;
    display: block;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/login/Login.vue